module.exports = __webpack_public_path__ + "img/@tmp_course_thumbnail_01.fa8fb5f5.jpg";